<template>
  <v-dialog v-model="visible" max-width="445" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          @click.native="cancel"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-5">
        {{ $t(`${namespace}.text`) }}
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a
          v-if="!isFetching"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="cancel"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          class="mr-0"
          :disabled="isFetching"
          :loading="isFetching"
          color="accent"
          depressed
          round
          @click.prevent="handleSubmit"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DisableIncentivesDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    saasByRideDiscountId: {
      type: String,
      default: null
    },
    percentDiscountId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      company: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Components.Incentives.dialogs.disable',
      isFetching: false
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },

    close () {
      this.$emit('close')
    },

    async cancelSaasByRide (discountId) {
      const companyId = this.company && this.company.id ? this.company.id : null
      await this.$apiService.cancelDiscount(companyId, discountId)
    },

    async cancelPercent (discountId) {
      const companyId = this.company && this.company.id ? this.company.id : null
      await this.$apiService.cancelDiscount(companyId, discountId)
    },

    async handleSubmit () {
      this.isFetching = true

      try {
        await Promise.all([
          this.cancelSaasByRide(this.saasByRideDiscountId),
          this.cancelPercent(this.percentDiscountId)
        ])

        this.close()
      } catch (err) {
        console.log('ERROR:', err)
      }

      this.isFetching = false
    }
  }
}
</script>
